<div class="line {{type}}" [ngStyle]="style()"
  [ngbTooltip]="tooltip || null"
  container="body">
  <div class="arrow-point"></div>
</div>
